import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { ROUTE_UI_SECTION_NAME } from '../../../../../constants/route'
import { useSectionPermissions } from '../../../../../hooks'
import { useUserProfileContext } from '../../../../User'
import {
  getUserProfilePageHeaderFooterAddNewOptions,
  useUserProfilePageHeaderFooterActions,
} from '../../../UserProfilePageHeaderFooter'
import { isUserProfilePageActionsWidgetActionDownload } from '../../UserProfilePageActionsWidget.utils'
import { useUserProfilePageDownloadAllFilesAction } from '../useUserProfilePageDownloadAllFilesAction'

export function useUserProfilePageActionsWidgetHandlers({
  getAddNewOptions = getUserProfilePageHeaderFooterAddNewOptions,
} = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const { userData } = useUserProfileContext()

  const { canView: canViewChats } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.chats,
  })
  const { canCreate: canCreateEmails } = useSectionPermissions({
    sectionName: ROUTE_UI_SECTION_NAME.mails,
  })

  const { actionHandlers, getUploadFileInputProps } =
    useUserProfilePageHeaderFooterActions()

  const { handleClickDownloadAll } = useUserProfilePageDownloadAllFilesAction()

  const addNewOptions = userData
    ? getAddNewOptions({
        canCreateEmails,
        canViewChats,
        t,
        userData,
      })
    : EMPTY_LIST

  function handleSelectAddNewOption({ value }) {
    actionHandlers[value]?.()
  }

  function handleClickAction({ value }) {
    if (isUserProfilePageActionsWidgetActionDownload(value)) {
      handleClickDownloadAll()

      return
    }

    actionHandlers[value]?.()
  }

  return {
    addNewOptions,
    getUploadFileInputProps,
    handleClickAction,
    handleSelectAddNewOption,
  }
}
